import * as React from 'react';
// import logo from './logo.svg';
// import './App.css';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { ThemeProvider } from '@mui/material/styles';

import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';

import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import Menu from '@mui/material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import AdbIcon from '@mui/icons-material/Adb';
import Alert from '@mui/material/Alert';

import { createRoot } from "react-dom/client";
import {
  createBrowserRouter,
  RouterProvider,
  Routes,
  Route,
  Link as RouteLink,
  useNavigate,
  useLocation,
  Navigate,
  Outlet,
  redirect,
  useHref
} from "react-router-dom";

import {useAuth} from '../context/AuthContext'

//  import Grid2  from '@mui/material/Unstable_Grid2';
import {default as Grid2} from '@mui/material/Grid';

import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';

import ArrowForwardRounded from '@mui/icons-material/ArrowForwardRounded'

//import { alpha } from '@mui/material/styles';
//import Table from '@mui/material/Table';
//import TableBody from '@mui/material/TableBody';
//import TableCell from '@mui/material/TableCell';
//import TableContainer from '@mui/material/TableContainer';
//import TableHead from '@mui/material/TableHead';
//import TablePagination from '@mui/material/TablePagination';
//import TableRow from '@mui/material/TableRow';
//import TableSortLabel from '@mui/material/TableSortLabel';
//import Toolbar from '@mui/material/Toolbar';
//import Typography from '@mui/material/Typography';
//import Paper from '@mui/material/Paper';
//import Checkbox from '@mui/material/Checkbox';
//import IconButton from '@mui/material/IconButton';
//import Tooltip from '@mui/material/Tooltip';
//import FormControlLabel from '@mui/material/FormControlLabel';
//import Switch from '@mui/material/Switch';
//import DeleteIcon from '@mui/icons-material/Delete';
//import FilterListIcon from '@mui/icons-material/FilterList';
//import { visuallyHidden } from '@mui/utils';

// import { DataGrid, GridRowsProp, GridColDef,GridRowId,GridToolbar } from '@mui/x-data-grid';

import {IMotoBrand,IMotoBrandResponse,IMotopageProps,IMotoAvRow,IMotoAvResponse,IMotoAvRowGrp,IMotoAvListProps} from './PageInterfaces'

import MotoVersList from './components/MotoVersList'
import MotoOrder from './components/MotoOrder'

import {returnBasenameUrl} from '../utils'

function MotoBrandCard(props:IMotopageProps){
  //const basename = useHref('/');
  const basename = returnBasenameUrl();
  function btnOrderclick(brand:IMotoBrand){
    props.cbf(brand)
  }
    return(
    <Card sx={{ maxWidth: 345 }}>
    <CardMedia
      sx={{ height: 140 }}
      image={`${basename}images/${props.brand.cardlogo}`} 
      title={` `}
    />
    <CardContent>
      {/* <Typography gutterBottom variant="h5" component="div">
      {`${props.brand.description}`}
      </Typography> */}
      <Typography variant="body2" color="text.secondary">
        {`${props.brand.description}`}
      </Typography>
    </CardContent>
    <CardActions>
      <Button size="small" variant="outlined" onClick={(e)=>{btnOrderclick(props.brand)}}>{'Διαθεσιμοτητα ΠΑΡΑΓΓΕΛΙΑ '}<ArrowForwardRounded /></Button>
    </CardActions>
  </Card>
    )
}

//    function MovoAvList(props:IMotoAvListProps){
//   const [order, setOrder] = React.useState<Order>('asc');
//   const [orderBy, setOrderBy] = React.useState<keyof IMotoAvRow>('COMNAME');
//   const [selected, setSelected] = React.useState<readonly number[]>([]);
//   const [page, setPage] = React.useState(0);
//   const [dense, setDense] = React.useState(false);
//   const [rowsPerPage, setRowsPerPage] = React.useState(5);

//   console.log(props.motolist)

//   let lrows = undefined
//   if(props.motolist) {
//     lrows = []    
//     props.motolist.forEach(element => {    
//       let el = {
//         grpKey: element.grpKey,
//         vhstatus: element.vhstatus,
//         grpsum: element.grpsum,
//         COMPANY: element.grpObj.COMPANY,
//         SODTYPE: element.grpObj.SODTYPE,
//         MTRMARK: element.grpObj.MTRMARK,
//         MTRMODEL: element.grpObj.MTRMODEL,
//         MARKCODE: element.grpObj.MARKCODE,
//         MDLCODE: element.grpObj.MDLCODE,
//         MTRGROUP: element.grpObj.MTRGROUP,
//         cccVMODEL: element.grpObj.cccVMODEL,
//         MTRL: element.grpObj.MTRL,
//         CODE: element.grpObj.CODE,
//         CODE1: element.grpObj.CODE1,
//         CODE2: element.grpObj.CODE2,
//         NAME: element.grpObj.NAME,
//         NAME1: element.grpObj.NAME1,
//         ISACTIVE: element.grpObj.ISACTIVE,
//         MTRONORDER: element.grpObj.MTRONORDER,
//         MTRTHIRD: element.grpObj.MTRTHIRD,
//         BUSUNITS: element.grpObj.BUSUNITS,
//         MTRCATEGORY: element.grpObj.MTRCATEGORY,
//         CCCNVEHSTATUS: element.grpObj.CCCNVEHSTATUS,
//         QTY1: element.grpObj.QTY1,
//         QIMP: element.grpObj.QIMP,
//         MTRSEASON: element.grpObj.MTRSEASON,
//         CCCLENGTH: element.grpObj.CCCLENGTH,
//         QPARAK: element.grpObj.QPARAK,
//         QDESM: element.grpObj.QDESM,
//         MARKNAME: element.grpObj.MARKNAME,
//         MDLNAME: element.grpObj.MDLNAME,
//         MNFMODEL: element.grpObj.MNFMODEL,
//         MNFVERSION: element.grpObj.MNFVERSION,
//         COMNAME: element.grpObj.COMNAME,
//         COLRCOD: element.grpObj.COLRCOD,
//         COLRNAME: element.grpObj.COLRNAME,
//         MGCODE: element.grpObj.MGCODE,
//         MGNAME: element.grpObj.MGNAME,
//         VHPRICELI: element.grpObj.VHPRICELI,
//         PRILICODE: element.grpObj.PRILICODE,
//         GENDISCPERC: element.grpObj.GENDISCPERC,
//         GENDISCAMNT: element.grpObj.GENDISCAMNT,
//         GENCOMMPERC: element.grpObj.GENCOMMPERC,
//         GENCOMMAMNT: element.grpObj.GENCOMMAMNT,
//         PRICER: element.grpObj.PRICER,
//         PRICEW: element.grpObj.PRICEW,
//         DISCRPERC: element.grpObj.DISCRPERC,
//         DISCRAMNT: element.grpObj.DISCRAMNT,
//         BASICPRICE: element.grpObj.BASICPRICE,
//         MTRLOT: element.grpObj.MTRLOT,
//         ETTPRICE: element.grpObj.ETTPRICE,
//         DATEKT: element.grpObj.DATEKT,
//         DATCUSTMS: element.grpObj.DATCUSTMS,
//         DATAFX: element.grpObj.DATAFX
//       }
//       lrows.push(el)
//     });
//   }
//   // const rows = (props.motolist) ? props.motolist : undefined
//   const rows = lrows

//   const motoAvColumns : GridColDef[] = [  // , width: 150
//   { field: 'grpKey',
//   type: 'string',
//   headerName: 'grpKey',
//   disableReorder: false,
//   hideable: false,
//   flex:1
// },
// { field: 'MTRL',
// type: 'string',
// headerName: 'MTRL',
// disableReorder: false,
// hideable: false,
// flex:1
// },
// { field: 'vhstatus',
// type: 'string',
// headerName: 'vhstatus',
// disableReorder: false,
// hideable: false,
// flex:1
// },
//   { field: 'COMNAME',
//     type: 'string',
//     headerName: 'Εκδοση',
//     disableReorder: false,
//     hideable: false,
//     flex:4
//   },
//   {
//     field: 'COLRNAME',
//     type: 'string',
//     headerName: 'Χρώμα',
//     disableReorder: true,
//     hideable: false,
//     flex:2
//   },
//   {
//     field: 'PRICEW',
//     type: 'number',
//     headerName: 'ΧΤ',
//     disableReorder: true,
//     hideable: false,
//     flex:1
//   },
//   {
//     field: 'ETTPRICE',
//     type: 'number',
//     headerName: 'ΕΤΤ',
//     disableReorder: true,
//     hideable: false,
//     flex:1
//   }
// ]

// function getRowId(row:IMotoAvRowGrp) {
//   return row.grpKey;
// }

//   /*   const handleRequestSort = (
//     event: React.MouseEvent<unknown>,
//     property: keyof Data,
//   ) => {
//     const isAsc = orderBy === property && order === 'asc';
//     setOrder(isAsc ? 'desc' : 'asc');
//     setOrderBy(property);
//   };

//   const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
//     if (event.target.checked) {
//       const newSelected = rows.map((n) => n.id);
//       setSelected(newSelected);
//       return;
//     }
//     setSelected([]);
//   };

//   const handleClick = (event: React.MouseEvent<unknown>, id: number) => {
//     const selectedIndex = selected.indexOf(id);
//     let newSelected: readonly number[] = [];

//     if (selectedIndex === -1) {
//       newSelected = newSelected.concat(selected, id);
//     } else if (selectedIndex === 0) {
//       newSelected = newSelected.concat(selected.slice(1));
//     } else if (selectedIndex === selected.length - 1) {
//       newSelected = newSelected.concat(selected.slice(0, -1));
//     } else if (selectedIndex > 0) {
//       newSelected = newSelected.concat(
//         selected.slice(0, selectedIndex),
//         selected.slice(selectedIndex + 1),
//       );
//     }
//     setSelected(newSelected);
//   };
//   */
//   const handleChangePage = (event: unknown, newPage: number) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   const handleChangeDense = (event: React.ChangeEvent<HTMLInputElement>) => {
//     setDense(event.target.checked);
//   };

//   const isSelected = (id: number) => selected.indexOf(id) !== -1;
//   // Avoid a layout jump when reaching the last page with empty rows.
//   const emptyRows =
//   page > 0 ? Math.max(0, (1 + page) * rowsPerPage - ((props.motolist) ? props.motolist?.length : 0)) : 0;

//   // const visibleRows = React.useMemo(
//   //   () =>
//   //     stableSort(rows, getComparator(order, orderBy)).slice(
//   //       page * rowsPerPage,
//   //       page * rowsPerPage + rowsPerPage,
//   //     ),
//   //   [order, orderBy, page, rowsPerPage],
//   // );
  
//   return (
//     <Box component="section" sx={{m: 1}}> {/*  sx={{ width: '100%' }} */}
    
//     {/* start of muix data-grid  */}
//     <Paper sx={{ width: '100%', mb: 2 }}>
//       <Avatar  alt="Remy Sharp"  src={`${process.env.REACT_APP_MAIN_ROOT}images/${props?.brand?.cardlogo}`}  sx={{ width: 345, height: 140 }} />
//       <DataGrid rows={rows} columns={motoAvColumns} getRowId={getRowId}
//       disableColumnMenu
//       slots={{ toolbar: GridToolbar }}
//       slotProps={{
//         columnsManagement: {
//           toggleAllMode: 'filteredOnly',          
//         }, 
//         toolbar: {printOptions: { disableToolbarButton: true },csvOptions: { disableToolbarButton: true },}
//       }} 
//       />
//     </Paper>
//     {/* end of muix data-grid  */}

//     {/* start of mui table  */}
//     {/*  discontinued 
//     <Paper sx={{ width: '100%', mb: 2 }}>
//       <MotoAvEnhTableToolbar numSelected={selected.length} />
//       <TableContainer>
//         <Table
//           sx={{ minWidth: 750 }}
//           aria-labelledby="tableTitle"
//           size={dense ? 'small' : 'medium'}
//         >
//           <MotoAvEnhTableHead
//             numSelected={selected.length}
//             order={order}
//             orderBy={orderBy}
//             //onSelectAllClick={handleSelectAllClick}
//             //onRequestSort={handleRequestSort}
//             rowCount={(props.motolist) ? props.motolist?.length : 0}
//           />
//           <TableBody>
//             { //visibleRows.map((row, index) => {
//             props.motolist?.map((row, index) => {
//               const isItemSelected = isSelected(parseInt(row.MTRL));
//               const labelId = `enhanced-table-checkbox-${index}`;
              
//               return (
//                 <TableRow
//                   hover
//                   // onClick={(event) => handleClick(event, row.id)}
//                   role="checkbox"
//                   aria-checked={isItemSelected}
//                   tabIndex={-1}
//                   key={parseInt(row.MTRL)}
//                   selected={isItemSelected}
//                   sx={{ cursor: 'pointer' }}
//                 >
//                   <TableCell padding="checkbox">
//                     <Checkbox
//                       color="primary"
//                       checked={isItemSelected}
//                       inputProps={{
//                         'aria-labelledby': labelId,
//                       }}
//                     />
//                   </TableCell>
//                   <TableCell
//                     component="th"
//                     id={labelId}
//                     scope="row"
//                     padding="none"
//                   >
//                     {row.COMNAME}
//                   </TableCell>
//                   <TableCell align="left">{row.COLRNAME}</TableCell>
//                   <TableCell align="right">{row.PRICEW}</TableCell>
//                   <TableCell align="right">{row.ETTPRICE}</TableCell>

//                 </TableRow>
//               );
//             })}
//             {emptyRows > 0 && (
//               <TableRow
//                 style={{
//                   height: (dense ? 33 : 53) * emptyRows,
//                 }}
//               >
//                 <TableCell colSpan={6} />
//               </TableRow>
//             )}
//           </TableBody>
//         </Table>
//       </TableContainer>
//       <TablePagination
//         rowsPerPageOptions={[5, 10, 25]}
//         component="div"
//         count={(props.motolist) ? props.motolist?.length : 0}
//         rowsPerPage={rowsPerPage}
//         page={page}
//         onPageChange={handleChangePage}
//         onRowsPerPageChange={handleChangeRowsPerPage}
//       />
//     </Paper>
//       */}
//     {/* end of mui table  */}
//     <FormControlLabel
//       control={<Switch checked={dense} onChange={handleChangeDense} />}
//       label="Dense padding"
//     />
//   </Box>
//   )
// }


/* === CCCNVEHSTATUS  ====
0=Προς Παραγγελία
1=Σε Παραγγελία
2=Επιβεβ. Παραγγελία
3=Σε Παραγωγή
4=Παραχθέν
5=Τιμολογ.απο Προμηθευτή
6=Φορτωθέν
7=Αφιχθέν
8=Εκτελωνισμένο
9=Σε Διακιν/Αποθηκευση
10=Τιμολογημένο
11=Ταξινομημένο
90=Κατεστραμένο
91=Κλεμμένο
89=Πωληθέν από μεταφορά
92=Επιστροφή σε Προμηθευτή
================================
    COMPANY:string,
    SODTYPE:string,
    MTRMARK:string,
    MTRMODEL:string,
    MARKCODE:string,
    MDLCODE:string,
    MTRGROUP:string,
    cccVMODEL:string,
    MTRL:string,
    CODE:string,
    CODE1:string,
    CODE2:string,
    NAME:string,
    NAME1:string,
    ISACTIVE:string,
    MTRONORDER:string,
    MTRTHIRD:string,
    BUSUNITS:string,
    MTRCATEGORY:string,
    CCCNVEHSTATUS:string,
    QTY1:string,
    QIMP:string,
    MTRSEASON:string,
    CCCLENGTH:string,
    QPARAK:string,
    QDESM:string,
    MARKNAME:string,
    MDLNAME:string,
    MNFMODEL:string,
    MNFVERSION:string,
    COMNAME:string,
    COLRCOD:string,
    COLRNAME:string,
    MGCODE:string,
    MGNAME:string,
    VHPRICELI:string,
    PRILICODE:string,
    GENDISCPERC:string,
    GENDISCAMNT:string,
    GENCOMMPERC:string,
    GENCOMMAMNT:string,
    PRICER:string,
    PRICEW:string,
    DISCRPERC:string,
    DISCRAMNT:string,
    BASICPRICE:string,
    MTRLOT:string,
    ETTPRICE:string
      DATEKT:string, "2024-05-14"
    DATCUSTMS:string,
    DATAFX:string

*/

function MotoAvRowComparator(a:IMotoAvRow, b:IMotoAvRow){
  // reverse compare status
  if(parseInt(a.MTRMODEL)<parseInt(b.MTRMODEL)) return 1
  else if(parseInt(a.MTRMODEL)>parseInt(b.MTRMODEL)) return 0
  else if(parseInt(a.cccVMODEL)<parseInt(b.cccVMODEL)) return 1
  else if(parseInt(a.cccVMODEL)>parseInt(b.cccVMODEL)) return 0
  else if(a.COLRCOD < b.COLRCOD) return 1
  else if(a.COLRCOD > b.COLRCOD) return -1
  else if(parseInt(a.CCCNVEHSTATUS)<parseInt(b.CCCNVEHSTATUS)) return 1
  else if(parseInt(a.CCCNVEHSTATUS)>parseInt(b.CCCNVEHSTATUS)) return 0
  else {
    var addatekt = new Date(a.DATEKT);
    var bddatekt = new Date(b.DATEKT);
    var addatcustms = new Date(a.DATCUSTMS);
    var bddatcustms = new Date(b.DATCUSTMS);
    var addatfx = new Date(a.DATAFX);
    var bddatfx = new Date(b.DATAFX);
    if( addatekt < bddatekt) return 1
    else if( addatekt > bddatekt) return -1
    else if(addatcustms>bddatcustms) return 1
    else if(addatcustms<bddatcustms) return -1
    else if(addatfx>bddatfx) return 1
    else if(addatfx>bddatfx) return -1
    else return 0
  }
}

function groupByMotoAvRow(array:IMotoAvRow[]) : IMotoAvRowGrp[] | null {
  let groups: IMotoAvRowGrp[] | null = []
  array.sort(MotoAvRowComparator).forEach(function (o) {
    let vhstatus = 'ONPRODUCTION'
    if( parseInt(o.CCCNVEHSTATUS)> 3 && parseInt(o.CCCNVEHSTATUS)< 7 ) vhstatus = 'ONWAY'
    else if( parseInt(o.CCCNVEHSTATUS)=== 7 ) vhstatus = 'LANDED'
    else if( parseInt(o.CCCNVEHSTATUS)===8 || parseInt(o.CCCNVEHSTATUS)===9) vhstatus = 'AVAILABLE'
    else vhstatus = 'UNAVAILABLE'
    const groupkey = o.cccVMODEL + '-' + o.COLRCOD+'-'+vhstatus
    let exo = groups?.find( g => g.grpKey === groupkey)
    if(exo===undefined || exo === null){
      let exo:IMotoAvRowGrp  = {
        grpKey: groupkey,
        grpObj: o,
        vhstatus: vhstatus,
        grpsum: 1
      }
      groups?.push(exo)
    } 
    else {
      exo.grpsum += 1
    }
  })
  return groups
}

function MotoPage(  ){
    let auth = useAuth();
    let location = useLocation();
    const [motobrands, setMotobrands] = React.useState<IMotoBrand[] | null>( null )
    const [selmotobrand, setSelmotobrand] = React.useState<IMotoBrand | null>( null )
    const [motoavlist, setMotoavlist] = React.useState<IMotoAvRowGrp[] | null>( null )
    const [selmotoav, setSelmotoav] = React.useState<IMotoAvRow | null>( null )
    const [isloading, setIsloading] = React.useState(true)
    const [pagestate, setPagestate] = React.useState('brandlist') // modelverlist' , 'motoorder'

    React.useEffect( () => {
        if(auth.userData.success!==true) return
        let token = auth.userData.token
        // console.log("auth.userData.token=",token)
        let usercode = auth.userData.username
        let postdata = {
            service: "getmotobramodvail", // "getmotoavailability",
            clientid: token,
            usercode: usercode
        }
        let body = `{"service": "getfixedmotobrands", "usercode":"${usercode}", "clientid":"${token}"}`
        const ms = Date.now();
        let basename=returnBasenameUrl()
        let url =`${basename}${process.env.REACT_APP_B2B_API_URL}?_t=${ms}`;
        fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json','Cache-Control': 'no-cache' },
            body: body
            ,cache: "no-store"
        })
        .then((response) =>  {
            if (!response.ok) return {} 
            else return response.json()
          })
        .then((data:any) => {
            // console.log(" MotoPage fetch getfixedmotobrands then ... data=",data)

            // const isSuccessMotoBrandResponse = (data: any): data is IMotoBrandResponse =>
            // typeof data === 'object' && data !== null &&
            // data.hasOwnProperty('success') && typeof data.success === 'boolean' &&
            // data.hasOwnProperty('rows') in data && typeof data.rows === 'object';
            const isSuccessMotoBrandResponse = (data: any): data is IMotoBrandResponse =>
            typeof data === 'object' && data !== null && data.hasOwnProperty('success') && typeof data.success === 'boolean' ;
            if (isSuccessMotoBrandResponse(data) && data.success!==true)
            {
              console.log(" fetched  data NOT Success MotoBrandResponse")
              setMotobrands(  null )
            }
            else {
                console.log("data.hasOwnProperty('rows')",data.hasOwnProperty('rows'),"typeof data.rows",typeof data.rows,"Array.isArray(data.rows)",Array.isArray(data.rows),"data.rows.length",data.rows.length)
                if(data.hasOwnProperty('rows') && typeof data.rows === 'object' && Array.isArray(data.rows) && data.rows.length>0){
                    //const motosdata: IMotoBrand[] = data.rows
                    setMotobrands(  data.rows )
                    console.log(" fetched data Success rows Array set")
                }
                else {
                  setMotobrands(  null )
                  console.log(" fetched  data NOT rows Array")
                }
            }                         
          })
          .catch(function (error) {
            console.warn(error);
          }).finally(function () {
            setIsloading(false);
          });
        
    },[])

    React.useEffect( () => {
      if(auth.userData.success!==true) return
      if(selmotobrand===null || selmotobrand===undefined) return
      if(selmotobrand.id===null || selmotobrand.id===undefined) return
      
      let token = auth.userData.token
      let usercode = auth.userData.username
      let postdata = {
          service: "getmotoavailability", // "getmotoavailability",
          usercode: usercode,
          brand: selmotobrand?.id,
          clientid: token
      }
      let body = `{"service": "getmotoavailability", "usercode":"${usercode}", "brand": "${selmotobrand?.id}", "clientid":"${token}"}`
      const ms = Date.now();
      let basename=returnBasenameUrl()
      let url =`${basename}${process.env.REACT_APP_B2B_API_URL}?_t=${ms}`;
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json','Cache-Control': 'no-cache' },
        body: body 
        ,cache: "no-store"
      })
      .then((response) =>  {
        if (!response.ok) return {} 
        else return response.json()
      })
      .then((data:any) => {
        // console.log(" fetch then ... data=",data) // IMotoAvRows
        const isSuccessMotoAvResponse = (data: any): data is IMotoAvResponse =>
        typeof data === 'object' && data !== null && data.hasOwnProperty('success') && typeof data.success === 'boolean' ;
        if (isSuccessMotoAvResponse(data) && data.success!==true)
        {
          console.log(" fetched  data NOT Success IMotoAvResponse")
          setMotoavlist(  null )
        }
        else {
          // console.log("data.hasOwnProperty('rows')",data.hasOwnProperty('rows'),"typeof data.rows",typeof data.rows,"Array.isArray(data.rows)",Array.isArray(data.rows),"data.rows.length",data.rows.length)
          if(data.hasOwnProperty('rows') && typeof data.rows === 'object' && Array.isArray(data.rows) && data.rows.length>0){
              //const motosdata: IMotoBrand[] = data.rows
              setMotoavlist(  groupByMotoAvRow(data.rows) )
              console.log(" fetched data Success rows Array set")
          }
          else {
            setMotoavlist(  null )
            console.log(" fetched  data NOT rows Array")
          }
      } 
      })          
      .catch(function (error) {
        console.warn(error);
      }).finally(function () {
        setIsloading(false)
      });
      
    }, [selmotobrand])

    function selBrandCb(brand:IMotoBrand){
      // console.log('brand selected ',brand.code)
      setIsloading(true)
      setSelmotobrand(brand)
      setPagestate('modelverlist')
    }

    function selMotoCb(moto:IMotoAvRow)
    {
      // console.log('selMotoCb to order ',moto)
      // setIsloading(true)
      setSelmotoav(moto)
      setPagestate('motoorder')
    } 

    function retbackCb(newpagestate:string){
      // setMotoavlist(null)
      setPagestate(newpagestate)
    }

    return(<>
    {isloading===true && <CircularProgress />}
    {/* react js inline switch in renderer ... */}
    {{
      'brandlist': <Box component="section" sx={{m: 1}}>  
          <Typography>Moto Διαθεσιμότητα Παραγγελίες, Επιλογή Μάρκας</Typography>           
          <Box sx={{ flexGrow: 1 }}>
              <Grid2 container spacing={{ xs: 1, md: 2 }} columns={{ xs: 1, sm: 2, md: 3 }}>
                  {motobrands?.sort((mbr1,mbr2)=>{return mbr1.orderno-mbr2.orderno}).map( (motobrand)=>(
                      <Grid2 size={{ xs: 1, sm: 1, md: 1 }} key={motobrand.id.toString()}>
                          <MotoBrandCard brand={motobrand} cbf={selBrandCb} />
                      </Grid2>
                  ))}
              </Grid2>
            </Box>
          </Box> ,

      'modelverlist': <React.Fragment>
          <Typography>Moto Διαθεσιμότητα Παραγγελίες, Επιλογή έκδοσης, χρώματος</Typography>
          <MotoVersList brand={selmotobrand} motolist={motoavlist}
            retcb={retbackCb} retstate='brandlist' selMotoCb={selMotoCb}/> 
        </React.Fragment> ,
      
      'motoorder': <React.Fragment>
          <Typography>Moto Διαθεσιμότητα Παραγγελίες, Αποστολή παραγγελίας </Typography>
          <MotoOrder brand={selmotobrand} moto={selmotoav} retcb={retbackCb} retstate='brandlist'/> 
        </React.Fragment>

    }[pagestate] || <><p>unhandled motopage state</p></>}

  
    </>)
 }
export default MotoPage